/** Tab shell only. Image reveal and range interaction belong to Horizon's comparison slider. */
class DelsolWatchItWork extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    const selectedId = this.querySelector('[data-delsol-tab][aria-selected="true"]')?.dataset.delsolTab;
    const tablist = this.querySelector('[data-delsol-tablist]');
    if (!tablist) return;
    this.panels = [...this.querySelectorAll('[data-delsol-panel]')];

    // Resolve merchant labels from each rendered theme block, never from section.blocks settings.
    // Rebuild in panel order on reconnect so there are no duplicate or stale buttons after editor changes.
    this.tabs = this.panels.map((panel) => {
      const tab = document.createElement('button');
      tab.type = 'button';
      tab.className = 'delsol-watch__tab';
      tab.id = `${panel.id}-tab`;
      tab.dataset.delsolTab = panel.dataset.delsolPanel;
      tab.textContent = panel.dataset.delsolLabel;
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', panel.id);
      return tab;
    });
    tablist.replaceChildren(...this.tabs);
    this.removeAttribute('data-ready');
    if (!this.tabs.length) return;

    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.select(index), { signal });
      tab.addEventListener('keydown', (event) => {
        const rtl = getComputedStyle(this).direction === 'rtl';
        let next;
        if (event.key === 'ArrowRight') next = index + (rtl ? -1 : 1);
        if (event.key === 'ArrowLeft') next = index + (rtl ? 1 : -1);
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        next = (next + this.tabs.length) % this.tabs.length;
        this.select(next);
        this.tabs[next].focus();
      }, { signal });
    });

    // Shopify block selection bubbles from both the panel and its native static comparison child.
    this.addEventListener('shopify:block:select', (event) => {
      const panel = event.target.closest('[data-delsol-panel]');
      const index = this.panels.indexOf(panel);
      if (index !== -1) this.select(index);
    }, { signal });

    this.select(Math.max(0, this.tabs.findIndex((tab) => tab.dataset.delsolTab === selectedId)));
    this.setAttribute('data-ready', '');
  }

  select(index) {
    this.tabs.forEach((tab, position) => {
      const selected = position === index;
      tab.setAttribute('aria-selected', String(selected));
      tab.tabIndex = selected ? 0 : -1;
      const panel = this.panels[position];
      if (!panel) return;
      panel.hidden = !selected;
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', tab.id);
    });
  }

  disconnectedCallback() {
    this.controller?.abort();
  }
}

if (!customElements.get('delsol-watch-it-work')) {
  customElements.define('delsol-watch-it-work', DelsolWatchItWork);
}
